import { Component, Input, Output, EventEmitter, ViewChild , ElementRef} from '@angular/core';
import { MzBaseModal } from 'ngx-materialize';

/*
 * Modal para mensajes a usuario y envios de comentarios
 * 
 * By: jsolerh
 */
@Component({ templateUrl: './modals.component.html'})
export class ModalsComponent extends MzBaseModal {

  // datos de entrada por el servicio de modal
  @Input() public modal_title: string;
  @Input() public modal_body: string;
  @Input() public isComents: boolean = false;
  @Input() public depurar: boolean = true;

  // Emitter para salida de comentario
  @Output() onOkModalComment:EventEmitter<String>;
  @Output() onOkDepure:EventEmitter<Boolean>;
  
  @ViewChild("inputComent") 
  private comentField: ElementRef;

  public modal_comentario: string;  
  private dataError: string = "Campo invalido";
  private dataSuccess: string = "Campo correcto";

  public modalOptions: Materialize.ModalOptions = {
    dismissible: false, 
    opacity: .5,
    inDuration: 300, 
    outDuration: 200, 
    startingTop: '100%', 
    endingTop: '10%'  
  };

  constructor() {     
    super(); 
    this.onOkModalComment = new EventEmitter();
    this.onOkDepure = new EventEmitter();    
  }

  // si cancela modal emite null
  private cancelModal() {
    this.onOkModalComment.emit(null);
    this.modal_comentario ='';
    this.isComents= false;
    this.modalComponent.closeModal();
  }

  private cancelDepure() {
    this.onOkDepure.emit(null);
    this.modalComponent.closeModal();
  }

  // Aceptando el modal 
  public closeModal() {
        
    // si no cometario omite esta parte
    if( this.isComents ) {
        
        // no deja salir si no tiene comentario 
        if( this.modal_comentario == null || this.modal_comentario == '') { 
          this.comentField.nativeElement.focus();           
          return;
        }

        this.onOkModalComment.emit(this.modal_comentario)
        this.modal_comentario ='';
        this.isComents= false;
      } else if (this.depurar) {
        this.onOkDepure.emit(true);
      }
      
    this.modalComponent.closeModal();
  }
}
